import React from 'react';
import styled from '@xstyled/styled-components';
import { t } from 'ttag';

const StyledCarouselTinderText = styled.div`
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  margin: auto;
  width: 300px;
  text-align: center;
`;

export const CarouselTinderText = () => {
  return (
    <StyledCarouselTinderText>
      <h2>{t`No cards left!`}</h2>
      <br />
      {t`Great job! Move to the next sequence.`}
    </StyledCarouselTinderText>
  );
};
